module.exports = __webpack_public_path__ + "static/integration_737-c98ba52c4789c3f68eb94025fe67fd5d.png";